module.exports = __webpack_public_path__ + "static/media/settings-icon.87ec8c2e.svg";